import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { TicketBatchTicket } from './ticket-batch-ticket';


export class TicketBatch extends BaseEntity {

  id                : number;
  branch            : Branch	;
  theDate	          : Date	  ;
  description	      : string	;
  progressLevel     : number	;
  role              : Role	  ;
  person            : Person  ;
  forecastDate      : Date    ;

  assignedToRole    : Role	  ;
  processedByPerson : Person  ;
  processingDate    : Date    ;

  closedRole       : Role	    ;
  closedPerson     : Person   ;
  closingDate      : Date     ;
  closed           : boolean  ;
  closedByRole     : Role;
  closedByPerson   : Person;

  ticketBatchTickets    : TicketBatchTicket[];

  constructor() {
    super();

  }
}

	
